import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // scrollt immer nach oben
  }, [pathname]);

  return null; // Rendert nichts
};

export default ScrollToTop;
